import React from "react";
import { TextField } from "@mui/material";
import { Controller } from "react-hook-form";

//======= Textfield component for input element =======

//Important props : control, name, label, type
//Validation function and systems prop : rules
//Utils props: defaultValue, autoComplete, innerFunction
// 1) rules gets object and thats the react hook form rules prop
// 2) control prop gets control in react hookform control
// 3) name prop is our key in out submit data object. so choose carefully
// 4) You can set type to number ,text ,email and ... just NOT supported for type file. (making a component for input type file later)
// 5) you can also use innerFunction prop for using onchange event when value changes

export default function WBTextField ({ control, rules, type, name, label, defualtValue, autoComplete, innerFunction, isRequired, errorText, handleValidation, ...rest }) {
    return(
        <>
            <Controller
                name={name}
                control={control}
                defaultValue={defualtValue || ''}
                render={({ field: { onChange, value }, fieldState: { error } }) => (
                    <TextField
                        autoComplete={autoComplete}
                        label={label}
                        type={type}
                        value={value}
                        helperText={error ? error.message : null}
                        onChange={(event) => {
                            onChange(event.target.value)
                            if(innerFunction) {
                                innerFunction(event)
                            }
                        }}
                        error={!!error}
                        {...rest}
                    />
                )}
                rules={{
                    required: isRequired ? (errorText ? errorText : "وارد کردن این فیلد اجباری است.") : null,
                    validate: handleValidation
                }}
            />
        </>
    )
}